<template>
  <t-report-generate
      v-model="form"
      sub-validation-tag="sub-place-report-qrcode-A4-enterprise"
      default-pdf
      help="Geração de QR Codes no formato A4"
      origin="Teste de Origem"
      button-title="QR Code A4"
      java-report
      title="QR Code Formato A4">

    <template #default="{status}">

      <b-form-checkbox class="mt-2 mb-2" v-model="form.enableAllSpotFolder" switch>
        Gerar para todos pavimentos de um empreendimento?
      </b-form-checkbox>

      <t-input-code-label :command="'insert'" v-show="form.enableAllSpotFolder" :required="form.enableAllSpotFolder" :status="status" enterprise
                          v-model="form.enterpriseId"/>

      <t-input-code-label spot-folder
                          v-show="!form.enableAllSpotFolder" :required="!form.enableAllSpotFolder"
                          :status="status"
                          :command="'insert'"
                          v-model="form.spotFolderId"/>


      <b-form-checkbox class="mt-2 mb-2" v-model="form.logoEnable" switch>
        Inserir logomarca?
      </b-form-checkbox>

    </template>



  </t-report-generate>

</template>
<script>
import pageDefaultMixin from "@/mixins/page/pageDefaultMixin"
import pageReportItemMixin from "@/mixins/page/pageReportItemMixin"

export default {

  mixins: [pageDefaultMixin, pageReportItemMixin],
  name: 'ReportQRCodeA4Enterprise',
  data() {
    return {
      path: "checklist/report", //Path padrão para validação, porém página foi configurada para validação direta na mesma página (validationOtherPageId)
      form: {
        enterpriseId: 0,
        spotFolderId: 0,
        enableAllSpotFolder:true,
        logoEnable: true,
      },
      checklistOptions: [],
    }
  },
  props: {},
  methods: {

    mountedPrepare() {


    },
    async mountedContinued() {


    },



  },
  async mounted() {

    this.mountedPrepare()

    await this.mountedContinued()

  },
  computed: {},

}
</script>
